<template>
	<div
		ref="offer_block"
		v-if="globalStore.offer_block?.enable && globalStore.offer_block?.image"
		class="container">
		<div
			class="subcribe_section"
			:style="`background-image: url(${globalStore.offer_block?.image});`">
			<div class="overlay"></div>
			<div class="subcribe_section__content">
				<p class="title">{{ globalStore.offer_block.title }}</p>
				<p v-if="globalStore.offer_block?.subtitle" class="text-xl mt-3">
					{{ globalStore.offer_block.subtitle }}
				</p>
				<Button v-if="globalStore.offer_block?.btn_text && globalStore.offer_block?.btn_link" asChild variant="accent" class="mt-4 text-main" size="lg">
					<NuxtLink
						:to="globalStore.offer_block.btn_link"
						external
						>
						{{ globalStore.offer_block.btn_text }}
					</NuxtLink>
				</Button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Button } from '~/components/shadcn/ui/button';

const globalStore = useGlobalStore();
const offer_block = ref(null);

const updateHeight = () => {
	if (offer_block.value) {
		globalStore.setOfferBlockHeight(offer_block.value.offsetHeight);
	}
};

onMounted(() => {
	updateHeight();
	window.addEventListener('resize', updateHeight);
});

onUnmounted(() => {
	window.removeEventListener('resize', updateHeight);
});

watch(() => globalStore.offer_block, () => {
	nextTick(() => {
		updateHeight();
	});
}, { deep: true });
</script>

<style>
.subcribe_section .overlay {
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background: rgba(0, 31, 141, 0.7);
}

.subcribe_section__content{
    position: relative;
}
</style>
